import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  useTheme,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import NewspaperIcon from '@mui/icons-material/Newspaper';

const NewsPopup = ({ open, onClose, newsData, ticker }) => {
  const theme = useTheme();

  if (!newsData || !Array.isArray(newsData) || newsData.length === 0) {
    return null;
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <NewspaperIcon color="primary" />
          <Typography variant="h5" component="div">
            News for {ticker} ({newsData.length} articles)
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            maxHeight: '60vh',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: theme.palette.grey[100],
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: theme.palette.grey[400],
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: theme.palette.grey[600],
            },
          }}
        >
          {newsData?.map((newsItem, index) => (
            <Card
              key={index}
              sx={{
                m: 2,
                mb: index === newsData.length - 1 ? 2 : 1,
                boxShadow: theme.palette.mode === 'light' 
                  ? '0 2px 8px rgba(0,0,0,0.1)' 
                  : '0 2px 8px rgba(0,0,0,0.3)',
                borderRadius: 2,
                overflow: 'hidden',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: theme.palette.mode === 'light' 
                    ? '0 4px 16px rgba(0,0,0,0.15)' 
                    : '0 4px 16px rgba(0,0,0,0.4)',
                },
              }}
            >
              {/* Content Section - Full Width */}
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  p: 3,
                  '&:last-child': { pb: 3 },
                }}
              >
                  {/* Title */}
                  <Typography
                    component="h3"
                    onClick={() => {
                      if (newsItem?.url) {
                        window.open(newsItem.url, '_blank', 'noopener,noreferrer');
                      }
                    }}
                    sx={{
                      fontWeight: 600,
                      color: theme.palette.primary.main,
                      mb: 1,
                      lineHeight: 1.3,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      cursor: newsItem?.url ? 'pointer' : 'default',
                      '&:hover': newsItem?.url ? {
                        textDecoration: 'underline',
                        color: theme.palette.primary.dark,
                      } : {},
                      transition: 'all 0.2s ease-in-out',
                    }}
                  >
                    {newsItem?.title || 'No title available'}
                    {newsItem?.url && (
                      <Box
                        component="span"
                        sx={{
                          ml: 1,
                          fontSize: '0.8em',
                          opacity: 0.7,
                        }}
                      >
                        🔗
                      </Box>
                    )}
                  </Typography>

                  {/* Description/Text */}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      flex: 1,
                      lineHeight: 1.5,
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      mb: 2,
                    }}
                  >
                      {newsItem?.text || newsItem?.description || newsItem?.snippet || 'No description available'}
                  </Typography>

                  {/* Tags and Meta Info */}
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                    {/* Ticker */}
               

                    {/* Source and Date */}
                    <Box sx={{ ml: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      {newsItem?.publisher && (
                        <Typography variant="caption" color="text.secondary">
                          {newsItem?.source}
                        </Typography>
                      )}
                      {newsItem?.date && (
                        <Typography variant="caption" color="text.secondary">
                          {new Date(newsItem?.date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                
                </CardContent>
            </Card>
          ))}
        </Box>
      </DialogContent>

      <Divider />

     
    </Dialog>
  );
};

export default NewsPopup;
